// Names are labels, not identities, but the backend keeps them unique: the draft
// POST and the metadata PATCH both refuse a name another version already carries.

export const VERSION_NAME_MAX_LENGTH = 150;

// Trailing " (12)" — the numbering this module adds and re-reads.
const NUMBERED_SUFFIX = /^(.*?)\s*\((\d+)\)$/;

const normalize = (name: string) => name.trim().toLowerCase();

export const isNameTaken = (name: string, takenNames: string[]): boolean => {
  const candidate = normalize(name);
  return candidate !== '' && takenNames.some(taken => normalize(taken) === candidate);
};

// The first free "<stem> (N)" for a taken name, mirroring the wallet clone
// numbering ("X" → "X (1)" → "X (2)"), except that it skips names already in use
// instead of blindly bumping the suffix it finds.
export const nextAvailableName = (name: string, takenNames: string[]): string => {
  const base = name.trim();
  if (!isNameTaken(base, takenNames)) return base;

  const stem = base.match(NUMBERED_SUFFIX)?.[1].trim() || base;

  for (let counter = 1; ; counter += 1) {
    const suffix = ` (${counter})`;
    // Truncating the stem keeps the numbered name inside the backend's 150 cap.
    const candidate = stem.slice(0, VERSION_NAME_MAX_LENGTH - suffix.length).trim() + suffix;
    if (!isNameTaken(candidate, takenNames)) return candidate;
  }
};
